import { Box, Typography } from '@mui/material';

import usePromiseStatus from 'hooks/usePromiseStatus';

import { IDropdownMenuItemProps } from './types';
import { Button } from '../Button/Button';

import styles from './DropdownMenuItem.module.scss';

export const DropdownMenuItem: React.FC<IDropdownMenuItemProps> = ({
  label,
  icon,
  shouldCloseOnClick,
  onClick,
  closeMenu,
}) => {
  const { track, isPending } = usePromiseStatus();

  const handleClick = async () => {
    if (isPending) {
      return;
    }
    if (shouldCloseOnClick) {
      closeMenu();
    }

    if (onClick) {
      const clickResult = onClick();
      clickResult instanceof Promise ? await track(clickResult) : clickResult;
    }
  };

  return (
    <Box component="li" key={label} className={styles.listItem}>
      <Button fullWidth onClick={handleClick} className={styles.button} startIcon={icon} isLoading={isPending}>
        <Typography variant="subtitle1" className={styles.text}>{label}</Typography>
      </Button>
    </Box>
  );
};
